// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./convert_hero_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.convert-page {
  --convert-c-bg: #ffffff;
  --convert-c-text: #0b0e11;
  --convert-c-muted: #707a8a;
  --convert-c-border: #eaecef;
  --convert-c-hero-bg: #f5f6fa;
  --convert-c-usdt: #00c087;
  --convert-c-btc: #f7931a;
  --convert-c-cta: #1e2329;
  --convert-radius: 12px;
  --convert-radius-sm: 8px;
  --convert-font: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-family: var(--convert-font);
  color: var(--convert-c-text);
  background: #181a20;
  min-height: calc(100vh - 64px);
}

body.light_theme .convert-page {
  background: #fff;
}

.convert-page__hero {
  position: relative;
  padding: 73px 20px 56px;
  background-color: #181a20;
  background-image: none;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 743px;
}

body.light_theme .convert-page__hero {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.convert-page__heroCol.convert-page__heroCol--text {
  padding-top: 20px;
}

.convert-page__heroInner {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px 48px;
  align-items: start;
}

.convert-page__title {
  margin: 0 0 10px;
  font-size: 44px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0px;
  color: #fff;
}

body.light_theme .convert-page__title {
  color: #0b0e11;
}

.convert-page__titleToken--usdt {
  color: #26A17B;
}

.convert-page__titleToken--btc {
  color: #F09642;
}

.convert-page__lead {
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  color: #cdcdcd;
  max-width: 520px;
}

body.light_theme .convert-page__title {
  color: #262626;
}

body.light_theme .convert-page__lead {
  color: #303236;
}

.convert-page__card {
  background: #22262c;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.1);
  padding: 32px;
}

body.light_theme .convert-page__card {
  background: #fff;
}

.convert-page__cardHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0px 0 16px;
  margin: 0 0 12px;
}

.convert-page__tabs {
  display: flex;
  gap: 12px;
}

.convert-page__tab {
  position: relative;
  border: none;
  background: transparent;
  padding: 0px 4px 8px;
  font: inherit;
  font-size: 17px;
  font-weight: 700;
  color: #84888C;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.convert-page__tab--active {
  color: #fff;
  font-weight: 700;
}

body.light_theme .convert-page__tab--active {
  color: #0b0e11;
}

.convert-page__tab--active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  width: 35%;
  margin: 0 auto;
  bottom: 0;
  height: 3px;
  background: #fff;
  border-radius: 3px;
}

body.light_theme .convert-page__tab--active::after {
  background: #0b0e11;
}

.convert-page__tabEmoji {
  font-size: 14px;
  line-height: 1;
}

.convert-page__historyBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* width: 40px; */
  /* height: 40px; */
  flex-shrink: 0;
  border-radius: 10px;
  /* background: #1e2329; */
  color: #fff;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;
}

.convert-page__historyBtn:hover {
  background: #0b0e11;
  color: #fff;
}

.convert-page__historyBtn img {
  filter: invert(1);
}

.convert-page__historyBtn i {
  font-size: 20px;
}

.convert-page__form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.convert-page__form--placeholder {
  padding: 24px 0 8px;
  gap: 20px;
}

.convert-page__placeholderText {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--convert-c-muted);
}

/* Gray Spend / Receive panels (match convert UI card) */
.convert-page__ioPanel {
  background: #f5f6f70a;
  border-radius: 12px;
  padding: 16px 18px 18px;
  margin-bottom: 0;
  min-height: 124px;
}

body.light_theme .convert-page__ioPanel {
  background: #F5F6F7;
}

.convert-page__ioPanel--compact {
  min-height: auto;
  padding: 16px 18px;
}

.convert-page__autoTopRight {
  font-weight: 600;
  color: #fff;
}

body.light_theme .convert-page__autoTopRight {
  color: #0b0e11;
}

.convert-page__autoBigPct {
  font-size: 28px;
  font-weight: 700;
  color: #f3f3f3;
  line-height: 1.1;
}

body.light_theme .convert-page__autoBigPct {
  color: #2a2a2a;
}

body.light_theme .convert-page__autoSelect {
  color: #0b0e11;
}

.convert-page__autoSelect {
  border: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.convert-page__autoAdvanced {
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px 2px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font: inherit;
  font-size: 16px;
  font-weight: 800;
  color: #fff;
  cursor: pointer;
}

body.light_theme .convert-page__autoAdvanced {
  color: #0b0e11;
}

.convert-page__advancedPanel {
  width: 100%;
  padding: 8px 2px 2px;
}

.convert-page__advancedRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 0;
  border-top: 1px solid rgb(64 64 64 / 35%);
}

body.light_theme .convert-page__advancedRow {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.convert-page__advancedLabel {
  font-size: 14px;
  font-weight: 500;
  color: rgb(255 255 255 / 60%);
}

body.light_theme .convert-page__advancedLabel {
  color: rgba(11, 14, 17, 0.6);
}

.convert-page__advancedValueBtn {
  border: none;
  background: transparent;
  display: inline-flex;
  color: #fff;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 0;
}

body.light_theme .convert-page__advancedValueBtn {
  color: #0b0e11;
}

.convert-page__advancedValue {
  font-size: 15px;
  font-weight: 600;
}

.convert-page__advancedIcon {
  font-size: 18px;
  color: #fff;
}

body.light_theme .convert-page__advancedIcon {
  color: #0b0e11;
}

.convert-page__switch {
  width: 48px;
  height: 28px;
  border-radius: 999px;
  border: none;
  background: #e5e7eb;
  padding: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  transition: background 160ms ease, box-shadow 160ms ease;
}

.convert-page__switchThumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.16);
  transition: transform 160ms ease;
}

.convert-page__switch--on {
  background: rgba(17, 24, 39, 0.25);
  box-shadow: 0 0 0 1px rgba(17, 24, 39, 0.18) inset;
  justify-content: flex-end;
}

.convert-page__switch--on .convert-page__switchThumb {
  transform: translateX(0);
}

/* Plan Name modal (Advanced) */
.convert-page__planModalOverlay {
  position: fixed;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.45); */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 2147483647;
  background-color: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  animation: cp-fade-in 160ms ease-out both;
}

.convert-page__planModal {
  width: min(720px, 100%);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: cp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.convert-page__planModalHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 26px 14px;
}

.convert-page__planModalTitle {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.convert-page__planModalClose {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #9aa0a6;
  padding: 6px 10px;
  border-radius: 10px;
}

.convert-page__planModalClose:hover {
  background: #f3f4f6;
  color: #111827;
}

.convert-page__planModalBody {
  padding: 0 26px 18px;
}

.convert-page__planModalInput {
  width: 100%;
  border: none;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 14px 14px;
  font: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  outline: none;
}

.convert-page__planModalFoot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 12px 26px 22px;
}

.convert-page__planBtn {
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.convert-page__planBtn--ghost {
  background: #f3f4f6;
  color: #111827;
}

.convert-page__planBtn--primary {
  background: #303236;
  color: #fff;
}

/* Dark Theme Overrides for Plan Modal */
body:not(.light_theme) .convert-page__planModalOverlay {
  background-color: rgba(0, 0, 0, 0.4);
}

body:not(.light_theme) .convert-page__planModal {
  background: #181a20cf;
  color: #eaecef;
}

body:not(.light_theme) .convert-page__planModalTitle {
  color: #eaecef;
}

body:not(.light_theme) .convert-page__planModalClose {
  color: #848e9c;
}

body:not(.light_theme) .convert-page__planModalClose:hover {
  background: #2b3139;
  color: #eaecef;
}

body:not(.light_theme) .convert-page__planModalInput {
  background: #2b3139;
  color: #eaecef;
}

body:not(.light_theme) .convert-page__planBtn--ghost {
  background: #2b3139;
  color: #eaecef;
}

body:not(.light_theme) .convert-page__planBtn--primary {
  background: #d1aa67;
  color: #ffffff;
}

/* Auto-Invest schedule picker popover */
.convert-page__ioTop {
  position: relative;
}

.convert-page__investPopover {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 18px);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  z-index: 10;
  --cp-invest-head-h: 34px;
  --cp-invest-head-gap: 8px;
  --cp-invest-row-h: 48px;
}

.convert-page__investCols {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: 100%;
}

.convert-page__investCol {
  padding: 16px 18px 14px;
  min-width: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  max-height: calc(var(--cp-invest-head-h) + var(--cp-invest-head-gap) + (7 * var(--cp-invest-row-h)));
}

.convert-page__investCol+.convert-page__investCol {
  border-left: 1px solid #eef0f2;
}

.convert-page__investColHead {
  font-size: 16px;
  font-weight: 600;
  /* color: #9aa0a6; */
  /* height: var(--cp-invest-head-h); */
  display: flex;
  align-items: center;
  margin-bottom: var(--cp-invest-head-gap);
}

.convert-page__investRow {
  width: 100%;
  border: none;
  background: transparent;
  padding: 12px 6px;
  min-height: var(--cp-invest-row-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  border-radius: 12px;
}

.convert-page__investRow:hover {
  background: #f4f5f7;
}

.convert-page__investRowText {
  font-size: 15px;
  font-weight: 400;
  min-width: 0;
  flex: 1 1 auto;
  overflow-wrap: anywhere;
  word-break: normal;
}

.convert-page__investCheck {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #111827;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
}

/* Invest At — mobile bottom sheet (portal) */
.convert-page__investSheetOverlay {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  background: rgb(255 255 255 / 20%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  animation: cp-fade-in 160ms ease-out both;
}

.convert-page__investSheet {
  width: 100%;
  max-height: min(92vh, 920px);
  background: #fff;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.2);
  padding: 4px 0 calc(10px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  min-height: 0;
  animation: cp-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes cp-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes cp-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes cp-sheet-up {
  from {
    transform: translateY(18px);
  }

  to {
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {

  .convert-page__planModalOverlay,
  .convert-page__planModal,
  .convert-page__investSheetOverlay,
  .convert-page__investSheet {
    animation: none !important;
  }
}

.convert-page__investSheetHandle {
  width: 44px;
  height: 5px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.12);
  margin: 4px auto 6px;
  flex-shrink: 0;
}

.convert-page__investPopover--mobileSheet {
  position: relative;
  left: auto;
  right: auto;
  top: auto;
  overflow: visible;
  z-index: auto;
  box-shadow: none;
  border-radius: 0;
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(78vh, 720px);
  margin: 0 0 2px;
  --cp-invest-head-h: 30px;
  --cp-invest-head-gap: 6px;
  --cp-invest-row-h: 44px;
}

.convert-page__investPopover--mobileSheet .convert-page__investCols {
  height: 100%;
  max-height: 100%;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr) minmax(0, 0.85fr);
}

.convert-page__investPopover--mobileSheet .convert-page__investCol {
  padding: 8px 10px 8px;
}

.convert-page__investPopover--mobileSheet .convert-page__investColHead {
  font-size: 13px;
  font-weight: 600;
  padding: 0 2px;
}

.convert-page__investPopover--mobileSheet .convert-page__investRow {
  gap: 6px;
  padding: 10px 2px;
  min-height: var(--cp-invest-row-h);
}

.convert-page__investPopover--mobileSheet .convert-page__investRowText {
  font-size: 12px;
  line-height: 1.3;
}

.convert-page__autoCoinWrap {
  position: relative;
  flex-shrink: 0;
}

.convert-page__autoCoinMenu {
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  width: 260px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.06);
  padding: 10px;
  z-index: 5;
}

.convert-page__autoCoinItem {
  width: 100%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font: inherit;
}

.convert-page__autoCoinItem:hover {
  background: #f4f5f7;
}

.convert-page__autoCoinLeft {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.convert-page__autoCoinMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.convert-page__autoCoinCode {
  font-size: 16px;
  font-weight: 600;
}

.convert-page__autoCoinBal {
  font-size: 15px;
  font-weight: 500;
  color: #9aa0a6;
  line-height: 16px;
}

.convert-page__autoCoinCheck {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #111827;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}

.convert-page__ioTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0px;
}

.convert-page__ioCaption {
  font-size: 15px;
  color: var(--convert-c-muted);
}

body.light_theme .convert-page__availDash {
  color: #0b0e11;
}

.convert-page__ioAvail {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
}

body.light_theme .convert-page__ioAvail {
  color: #1d1d1d;
}

.convert-page__availDash {
  font-weight: 600;
  color: #fff;
}


.Convert_mid_btc_del {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.convert-page__swapMid {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  margin: 2px 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.convert-page__addBalBtn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
}

.convert-page__addBalCircle {
  width: 14px;
  height: 14px;
  padding-bottom: 2px;
  border-radius: 50%;
  /* border: 1px solid #c8cdd3; */
  background: #303236;
  font-size: 13px;
  font-weight: 700;
  line-height: 15px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.convert-page__addBalBtn:hover .convert-page__addBalCircle {
  border-color: #ffffff;
  color: #ffffff;
}

.convert-page__ioMain {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.convert-page__coinSelect {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  padding: 4px 0;
  cursor: pointer;
  font: inherit;
  flex-shrink: 0;
}

.convert-page__coinSelect:hover .convert-page__coinTicker {
  opacity: 0.85;
}

.convert-page__coin-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 50%;
  flex-shrink: 0;
}

.convert-page__coinTicker {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
}

body.light_theme .convert-page__coinTicker {
  color: #0b0e11;
}

.convert-page__caret {
  font-size: 18px;
  color: #98a2b3;
  margin-left: 2px;
}

/* Select Coin modal (Spend selector) */
.convert-page__coinModalOverlay {
  position: fixed;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.45); */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 2147483647;
  background-color: rgb(255 255 255 / 20%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.convert-page__coinModal {
  width: min(640px, 100%);
  max-height: min(86vh, 760px);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Add Funds modal (reuses overlay + head/close styles) */
.convert-page__fundsModal {
  width: min(760px, 100%);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.convert-page__fundsBody {
  padding: 0px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.convert-page__fundsCard {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 18px;
  border-radius: 14px;
  border: 1px solid #eef0f2;
  background: #ffffff8c;
  cursor: pointer;
  text-align: left;
}

.convert-page__fundsCard:hover {
  border-color: #e5e7eb;
  background: #fbfbfc;
}

.convert-page__fundsIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #111827;
  font-size: 22px;
}

.convert-page__fundsMeta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.convert-page__fundsTitle {
  font-size: 16px;
  font-weight: 600;
}

.convert-page__fundsDesc {
  font-size: 14px;
  font-weight: 500;
  color: #8e9299;
  line-height: 1.35;
}

.convert-page__fundsSub {
  font-size: 14px;
  font-weight: 500;
  color: #8e9299;
}

.convert-page__fundsMore {
  width: 100%;
  border: none;
  background: transparent;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 0 10px;
  cursor: pointer;
}

/* Auto-Invest "Choose Coin" modal */
.convert-page__chooseModal {
  width: min(720px, 100%);
  max-height: min(86vh, 820px);
  background: #ffffff18;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.convert-page__chooseBody {
  padding: 0 24px 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.convert-page__chooseBanner {
  width: 100%;
  border: 1px solid #eef0f2;
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  text-align: left;
  margin: 0 0 14px;
}

.convert-page__chooseBannerLeft {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.convert-page__chooseFlame {
  font-size: 16px;
}

.convert-page__chooseList {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0 14px;
}

.convert-page__chooseRow {
  width: 100%;
  border: none;
  background: transparent;
  padding: 12px 6px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  text-align: left;
}


/* 
.convert-page__chooseRow--selected {
  background: #f3f4f6;
} */

.convert-page__chooseLeft {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.convert-page__chooseBox {
  width: 18px;
  height: 18px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  background: #fff;
  flex-shrink: 0;
}

.convert-page__chooseBox--on {
  background: #111827;
  border-color: #111827;
}

.convert-page__chooseBox--on::after {
  content: "✓";
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  height: 100%;
  width: 100%;
}

.convert-page__chooseFoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px 18px;
}

.convert-page__chooseChips {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
  max-width: 420px;
  max-height: 76px;
  overflow: auto;
}

.convert-page__chooseChip {
  border: none;
  background: #f3f4f6;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
}

.convert-page__chooseActions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.convert-page__chooseCount {
  font-size: 14px;
  font-weight: 800;
  color: #111827;
}

.convert-page__chooseConfirm {
  min-width: 180px;
  padding: 14px 18px;
  border-radius: 999px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.convert-page__chooseConfirm:disabled {
  background: #eef0f2;
  color: #c4c7ca;
  cursor: not-allowed;
}

/* Featured Portfolios modal */
.convert-page__featuredModal {
  width: min(760px, 100%);
  max-height: min(86vh, 860px);
  background: #ffffff10;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.convert-page__featuredBody {
  padding: 2px 24px 32px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.convert-page__featuredCard {
  background: none;
  /* border: 1px solid #f5f6f7; */
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0px 0px 4px #99999966;
}

.convert-page__featuredTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.convert-page__featuredMid .convert-page__featuredMetric:last-child {
  align-items: end;
}

.convert-page__featuredTitleRow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.convert-page__featuredTitle {
  font-size: 18px;
  font-weight: 600;
}

.convert-page__featuredInfo {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(17, 24, 39, 0.08);
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 900;
}

.convert-page__featuredCopy {
  border: none;
  background: #303236;
  color: #fff;
  padding: 10px 30px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.convert-page__featuredMid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
  margin-bottom: 12px;
}

.convert-page__featuredMetric {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.convert-page__featuredLabel {
  font-size: 14px;
  font-weight: 500;
  color: #9aa0a6;
}

.convert-page__featuredValue {
  font-size: 22px;
  font-weight: 700;
}

.convert-page__featuredIcons {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.convert-page__featuredIcon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.convert-page__featuredTags {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #9aa0a6;
  font-size: 14px;
  font-weight: 400;
}

.convert-page__featuredTag {
  color: #9aa0a6;
}

.convert-page__coinModalHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
}

.convert-page__coinModalTitle {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.convert-page__coinModalClose {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #9aa0a6;
  padding: 6px 10px;
  border-radius: 10px;
}

.convert-page__coinModalClose:hover {
  color: #111827;
}

.convert-page__coinModalBody {
  padding: 0 20px 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
}

.convert-page__coinModalTabs {
  display: flex;
  gap: 0;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 14px;
}

.convert-page__coinModalTab {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 10px 12px;
  border-radius: 10px;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  color: #8e9299;
  cursor: pointer;
}

.convert-page__coinModalTab--active {
  background: #fff;
  color: #111827;
}

.convert-page__coinModalSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px;
  background: #f3f4f6;
  border-radius: 12px;
  margin-bottom: 12px;
}

.convert-page__coinModalSearchIcon {
  font-size: 18px;
  color: #8e9299;
}

.convert-page__coinModalSearchInput {
  border: none;
  background: transparent;
  flex: 1 1;
  min-width: 0;
  font: inherit;
  font-size: 14px;
  color: #262933;
  outline: none;
}

.convert-page__coinModalFilters {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 4px 2px 10px;
  margin-bottom: 8px;
}

.convert-page__coinModalFilter {
  border: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  color: #8e9299;
  cursor: pointer;
  position: relative;
  padding: 2px 0;
}

.convert-page__coinModalFilter--active {
  color: #111827;
}

.convert-page__coinModalFilter--active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 2px;
  background: #111827;
  border-radius: 2px;
}

.convert-page__coinModalList {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 520px;
  padding-right: 4px;
}

.convert-page__coinModalFoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0 2px;
}

.convert-page__coinModalCheck {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.convert-page__coinModalCheck input {
  width: 18px;
  height: 18px;
}

.convert-page__coinModalConfirm {
  min-width: 220px;
  padding: 14px 22px;
  border-radius: 999px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.convert-page__coinModalConfirm:disabled {
  background: #eef0f2;
  color: #c4c7ca;
  cursor: not-allowed;
}

.convert-page__coinRow {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border: none;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.convert-page__coinRow:hover {
  background: #f4f5f7;
}

.convert-page__coinRow--active {
  background: #f3f4f6;
}

.convert-page__coinRowIcon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: contain;
  flex-shrink: 0;
}

.convert-page__coinRowMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.convert-page__coinRowTop {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.convert-page__coinRowCode {
  font-size: 16px;
  font-weight: 600;
}

.convert-page__coinRowBadge {
  font-size: 12px;
  font-weight: 800;
  color: #d1aa67;
  background: rgba(209, 170, 103, 0.18);
  padding: 4px 8px;
  border-radius: 8px;
  flex-shrink: 0;
}

.convert-page__coinRowName {
  font-size: 13px;
  font-weight: 600;
  color: #8e9299;
}

.convert-page__amountBlock {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.convert-page__amountBlock--receive {
  justify-content: flex-start;
}

.convert-page__amountInput {
  width: 100%;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 24px;
  font-weight: 700;
  color: #C4C7CA;
  text-align: right;
  padding: 4px 0;
  line-height: 1.2;
}

.convert-page__amountInput::placeholder {
  color: #C4C7CA;
  font-weight: 700;
}

.convert-page__amountInput:focus {
  outline: none;
}

.convert-page__maxPill {
  border: none;
  background: #fff;
  color: #000000;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 9px;
  border-radius: 50px;
  cursor: pointer;
}

.convert-page__maxPill:hover {
  border-color: #c8cdd3;
  color: #0b0e11;
}

.convert-page__swapMid {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  margin: 2px 0;
}

.convert-page__swapBtn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #EBEBEB;
  background: #F5F6F7;
  box-shadow: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #5e6673;
  font-size: 22px;
}

.convert-page__swapBtn:hover {
  color: #0b0e11;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
}

.convert-page__rate {
  margin: 12px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: var(--convert-c-muted);
  text-align: center;
}

.convert-page__cta {
  display: block;
  width: 100%;
  margin-top: 18px;
  padding: 15px 20px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  background: #303236;
  border-radius: 999px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.convert-page__cta:hover {
  filter: brightness(1.08);
  color: #fff;
}

@media (max-width: 480px) {
  .convert-page__ioMain {
    flex-wrap: wrap;
  }

  .convert-page__amountBlock {
    width: 100%;
  }

  .convert-page__amountInput {
    font-size: 20px;
  }

  .convert-page__maxPill {
    align-self: flex-end;
  }
}

/* Supported assets */
.convert-page__assetsSection {
  padding: 90px 20px 90px;
  max-width: 1240px;
  margin: 0 auto;
}

.convert-page__sectionTitle {
  margin: 0 0 10px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  letter-spacing: -0.02em;
}

body.light_theme .convert-page__sectionTitle {
  color: #262626;
}

.convert-page__sectionSub {
  margin: 0px auto 18px;
  max-width: 520px;
  text-align: center;
  font-size: 16px;
  line-height: 1.55;
  color: var(--convert-c-muted);
}

.convert-page__assetGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
}

@media (max-width: 991px) {
  .convert-page__assetGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}



.convert-page__assetCard {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px;
  cursor: pointer;
  border: 1px solid #eaecef0f;
  background: #ffffff0a;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #00000015;
  transition: 1s all;
  text-decoration: none;
  color: inherit;
}

a.convert-page__assetCard:hover {
  color: inherit;
}

body.light_theme .convert-page__assetCard {
  border: 1px solid #eaecef45;
  background: #fff;
}

.convert-page__assetCard:hover {
  transform: translateY(-5px);
}

.convert-page__assetCard--more {
  cursor: default;
}

.convert-page__assetIconImg {
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;
}

.convert-page__assetIcon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.convert-page__assetIcon--letter {
  font-size: 18px;
}

.convert-page__assetIcon--more {
  color: #000000;
  font-size: 24px;
  letter-spacing: 2px;
}

.convert-page__assetMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.convert-page__assetName {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}

body.light_theme .convert-page__assetName {
  color: #0b0e11;
}

.convert-page__assetHint {
  font-size: 16px;
  /* font-weight: 500; */
  color: var(--convert-c-muted);
}

/* FAQ */
.convert-page__faqSection {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px 72px;
  color: #fff;
}

body.light_theme .convert-page__faqSection {
  color: #0b0e11;
}

.convert-page__faqTitle {
  margin: 0 0 24px;
  font-size: 32px;
  font-weight: 700;
}

.convert-page__faqList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.convert-page__faqBtn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 4px;
  border: none;
  background: none;
  font: inherit;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  color: #ffffffc7;
  cursor: pointer;
}

body.light_theme .convert-page__faqBtn {
  color: #050606;
}

/* .convert-page__faqBtn:hover {
  color: var(--convert-c-muted);
} */

.convert-page__faqChev {
  font-size: 22px;
  color: var(--convert-c-muted);
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.convert-page__faqChev--open {
  transform: rotate(180deg);
}

.convert-page__faqPanel {
  padding: 0 4px 18px;
  font-size: 18px;
  line-height: 1.65;
  color: var(--convert-c-muted);
}

.convert-page__faqPanel p {
  margin: 0;
  font-size: 18px;
}

@media (max-width: 1440px) {

  .convert-page__title {
    font-size: 36px;
  }


}



@media (max-width: 1200px) {

  .convert-page__title {
    font-size: 30px;
  }

  .convert-page__faqBtn {
    font-size: 16px;
  }

  .convert-page__faqPanel p {
    font-size: 15px;
  }

  .convert-page__faqTitle {
    font-size: 26px;
  }

  .convert-page__lead {
    font-size: 15px;
  }

  .convert-page__amountInput {
    font-size: 18px;
  }

  .convert-page__hero {
    min-height: 650px;
  }


}


@media (max-width: 991px) {

  .convert-page__hero {
    min-height: 100%;
    padding: 30px 20px 50px;
  }

  .convert-page__coinModalOverlay {
    align-items: end;
    padding: 0px;
  }

  .convert-page__investRow:hover {
    background: none;
  }

  .convert-page__coin-icon {
    width: 24px;
    height: 24px;
  }

  .convert-page__coinTicker {
    font-size: 15px;
  }

  .convert-page__cta {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 14px;
  }

  .convert-page__coinModal {
    width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

  .convert-page__fundsModal {
    border-radius: 18px 18px 0px 0px;
  }

  .convert-page__chooseModal {
    width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

  .convert-page__planModalOverlay {
    align-items: end;
  }

  .convert-page__planModal {
    width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

}

@media (max-width: 767px) {

  .convert-page__fundsBody {
    height: 75vh;
    overflow: scroll;
  }

  .convert-page__heroInner {
    grid-template-columns: 1fr;
  }

  .convert-page__swapBtn {
    width: 50px;
    padding: 0px;
    height: 50px;
  }

  .convert-page__featuredModal {
    width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

  .convert-page__coinModalTitle {
    width: 90%;
    font-size: 20px;
  }

  .convert-page__lead {
    display: none;
  }

  .convert-page__title {
    font-size: 24px;
    text-align: center;
  }

  .convert-page__heroInner {
    gap: 15px;
  }

  .convert-page__card {
    padding: 20px;
  }

  .convert-page__hero {
    padding: 30px 15px 30px;
  }

  .convert-page__featuredTitle {
    font-size: 16px;
  }

  .convert-page__featuredCopy {
    padding: 8px 20px;
    font-size: 13px;
  }

  .convert-page__planBtn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .convert-page__chooseConfirm {
    min-width: 150px;
    padding: 10px 18px;
    font-size: 14px;
  }

  .convert-page__autoCoinItem {
    padding: 8px 5px;
  }

  .convert-page__autoCoinMenu {
    width: 200px;
  }

  .convert-page__featuredCard {
    padding: 18px;
  }

  .convert-page__autoBigPct {
    font-size: 20px;
  }

  .convert-page__coinRow {
    padding: 8px;
  }

  .convert-page__sectionSub {
    font-size: 15px;
  }

  .convert-page__faqTitle {
    font-size: 22px;
  }

  .convert-page__faqBtn {
    padding: 10px 4px;
    font-size: 15px;
  }

  .convert-page__faqPanel p {
    font-size: 14px;
  }

  .simple_earn_wrapper .convert-page__faqSection {
    padding: 0 0px 30px;
    margin: 20px 0px !important;
  }

}


@media (max-width: 660px) {

  .convert-page__assetGrid {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }


  .convert-page__fundsCard {
    padding: 15px;
  }

  .convert-page__planModalTitle {
    font-size: 20px;
    width: 90%;
  }

  .convert-page__assetCard {
    padding: 15px;
  }

  .convert-page__assetIconImg {
    width: 30px;
    height: 30px;
  }

  .convert-page__assetName {
    font-size: 15px;
  }

  .convert-page__assetHint {
    font-size: 14px;
  }

  .convert-page__amountInput {
    font-size: 15px;
  }

  .convert-page__coinRowCode {
    font-size: 14px;
  }

}

/* ==========================================
   Dark Theme (Default) Overrides for Modals
   ========================================== */
body:not(.light_theme) .convert-page__coinModalOverlay {
  background-color: rgba(0, 0, 0, 0.20);
}

body:not(.light_theme) .convert-page__coinModal,
body:not(.light_theme) .convert-page__fundsModal,
body:not(.light_theme) .convert-page__chooseModal,
body:not(.light_theme) .convert-page__featuredModal {
  background: #111214c2;
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: #ffffff;
  box-shadow: 0 20px 60px rgb(0 0 0 / 70%);
}

body:not(.light_theme) .convert-page__coinModalTitle {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinModalClose {
  color: #9aa0a6;
}

body:not(.light_theme) .convert-page__coinModalClose:hover {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinModalTabs {
  background: #1e2329;
}

body:not(.light_theme) .convert-page__coinModalTab {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__coinModalTab--active {
  background: #2b313c;
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinModalSearch {
  background: #1e2329;
  border: 1px solid rgba(255, 255, 255, 0);
}

body:not(.light_theme) .convert-page__coinModalSearchIcon {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__coinModalSearchInput {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinModalFilter {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__coinModalFilter--active {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinModalFilter--active::after {
  background: #ffffff;
}

body:not(.light_theme) .convert-page__coinRow,
body:not(.light_theme) .convert-page__chooseRow,
body:not(.light_theme) .convert-page__autoCoinItem,
body:not(.light_theme) .convert-page__investRow {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__coinRow:hover,
body:not(.light_theme) .convert-page__chooseRow:hover,
body:not(.light_theme) .convert-page__autoCoinItem:hover,
body:not(.light_theme) .convert-page__investRow:hover {
  background: rgba(255, 255, 255, 0.05);
}

body:not(.light_theme) .convert-page__coinRow--active {
  background: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .convert-page__coinRowName,
body:not(.light_theme) .convert-page__autoCoinBal,
body:not(.light_theme) .convert-page__chooseBox,
body:not(.light_theme) .convert-page__fundsDesc,
body:not(.light_theme) .convert-page__fundsSub {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__coinRowCode,
body:not(.light_theme) .convert-page__coinRowBalVal,
body:not(.light_theme) .convert-page__autoCoinCode,
body:not(.light_theme) .convert-page__chooseConfirm,
body:not(.light_theme) .convert-page__coinModalConfirm,
body:not(.light_theme) .convert-page__fundsTitle {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__fundsCard {
  background: #1e23295e;
  border-color: rgb(255 255 255 / 6%);
}

body:not(.light_theme) .convert-page__fundsCard:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
}

body:not(.light_theme) .convert-page__fundsIcon {
  background: #2b313c;
  color: #ffffff;
}

body:not(.light_theme) .convert-page__fundsMore {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__chooseBox {
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
}

body:not(.light_theme) .convert-page__chooseBox--on {
  background: #ffffff;
  border-color: #ffffff;
}

body:not(.light_theme) .convert-page__chooseBox--on::after {
  color: #111214;
}

body:not(.light_theme) .convert-page__chooseConfirm,
body:not(.light_theme) .convert-page__coinModalConfirm {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .convert-page__chooseConfirm:disabled,
body:not(.light_theme) .convert-page__coinModalConfirm:disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.3);
}

body:not(.light_theme) .convert-page__coinModalCheck {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__chooseChip {
  background: #2b313c;
  color: #ffffff;
}

body:not(.light_theme) .convert-page__chooseCount {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__chooseBanner {
  background: #1e232910;
  border-color: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .convert-page__chooseBannerLeft {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__featuredCard {
  background: #1e232910;
  box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .convert-page__featuredTitle {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__featuredInfo {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

body:not(.light_theme) .convert-page__featuredLabel {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__featuredValue {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__featuredTag {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__featuredCopy {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .convert-page__coinModalFoot,
body:not(.light_theme) .convert-page__chooseFoot {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .convert-page__autoCoinMenu {
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .convert-page__autoCoinCheck {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .convert-page__investPopover {
  background: #111214;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .convert-page__investCol+.convert-page__investCol {
  border-left: 1px solid rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .convert-page__investRow:hover {
  background: #2b313c;
}

body:not(.light_theme) .convert-page__investRowText {
  color: #ffffff;
}

body:not(.light_theme) .convert-page__investColHead {
  color: #8e9299;
}

body:not(.light_theme) .convert-page__investCheck {
  background: #ffffff;
  color: #111214;
}


@media screen and (max-width:580px) {


  .convert-page__faqBtn {
    padding: 10px 4px;
    font-size: 13px;
  }

  .convert-page__faqPanel p {
    font-size: 13px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ConvertPage/convert.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,iGAAiG;EACjG,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yDAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,cAAc;EACd,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,0EAA0E;EAC1E,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,oGAAoG;AACtG;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2EAA2E;AAC7E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0EAA0E;EAC1E,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;;AAGA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,QAAQ;AACR;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE;IACE,eAAe;EACjB;;;AAGF;;;;AAIA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;;AAGA;;EAEE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;AAEF;;AAEA;;EAEE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;AAEF;;;AAGA;;EAEE;IACE,8BAA8B;IAC9B,SAAS;EACX;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;+CAE+C;AAC/C;EACE,qCAAqC;AACvC;;AAEA;;;;EAIE,qBAAqB;EACrB,2CAA2C;EAC3C,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,+EAA+E;AACjF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;;;EAGE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".convert-page {\n  --convert-c-bg: #ffffff;\n  --convert-c-text: #0b0e11;\n  --convert-c-muted: #707a8a;\n  --convert-c-border: #eaecef;\n  --convert-c-hero-bg: #f5f6fa;\n  --convert-c-usdt: #00c087;\n  --convert-c-btc: #f7931a;\n  --convert-c-cta: #1e2329;\n  --convert-radius: 12px;\n  --convert-radius-sm: 8px;\n  --convert-font: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-family: var(--convert-font);\n  color: var(--convert-c-text);\n  background: #181a20;\n  min-height: calc(100vh - 64px);\n}\n\nbody.light_theme .convert-page {\n  background: #fff;\n}\n\n.convert-page__hero {\n  position: relative;\n  padding: 73px 20px 56px;\n  background-color: #181a20;\n  background-image: none;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 743px;\n}\n\nbody.light_theme .convert-page__hero {\n  background-color: #fff;\n  background-image: url(\"./convert_hero_bg.png\");\n}\n\n.convert-page__heroCol.convert-page__heroCol--text {\n  padding-top: 20px;\n}\n\n.convert-page__heroInner {\n  position: relative;\n  z-index: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px 48px;\n  align-items: start;\n}\n\n.convert-page__title {\n  margin: 0 0 10px;\n  font-size: 44px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0px;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__title {\n  color: #0b0e11;\n}\n\n.convert-page__titleToken--usdt {\n  color: #26A17B;\n}\n\n.convert-page__titleToken--btc {\n  color: #F09642;\n}\n\n.convert-page__lead {\n  margin: 0;\n  font-size: 18px;\n  line-height: 24px;\n  color: #cdcdcd;\n  max-width: 520px;\n}\n\nbody.light_theme .convert-page__title {\n  color: #262626;\n}\n\nbody.light_theme .convert-page__lead {\n  color: #303236;\n}\n\n.convert-page__card {\n  background: #22262c;\n  border-radius: 16px;\n  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.1);\n  padding: 32px;\n}\n\nbody.light_theme .convert-page__card {\n  background: #fff;\n}\n\n.convert-page__cardHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0px 0 16px;\n  margin: 0 0 12px;\n}\n\n.convert-page__tabs {\n  display: flex;\n  gap: 12px;\n}\n\n.convert-page__tab {\n  position: relative;\n  border: none;\n  background: transparent;\n  padding: 0px 4px 8px;\n  font: inherit;\n  font-size: 17px;\n  font-weight: 700;\n  color: #84888C;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.convert-page__tab--active {\n  color: #fff;\n  font-weight: 700;\n}\n\nbody.light_theme .convert-page__tab--active {\n  color: #0b0e11;\n}\n\n.convert-page__tab--active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 35%;\n  margin: 0 auto;\n  bottom: 0;\n  height: 3px;\n  background: #fff;\n  border-radius: 3px;\n}\n\nbody.light_theme .convert-page__tab--active::after {\n  background: #0b0e11;\n}\n\n.convert-page__tabEmoji {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.convert-page__historyBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  /* width: 40px; */\n  /* height: 40px; */\n  flex-shrink: 0;\n  border-radius: 10px;\n  /* background: #1e2329; */\n  color: #fff;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.convert-page__historyBtn:hover {\n  background: #0b0e11;\n  color: #fff;\n}\n\n.convert-page__historyBtn img {\n  filter: invert(1);\n}\n\n.convert-page__historyBtn i {\n  font-size: 20px;\n}\n\n.convert-page__form {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.convert-page__form--placeholder {\n  padding: 24px 0 8px;\n  gap: 20px;\n}\n\n.convert-page__placeholderText {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--convert-c-muted);\n}\n\n/* Gray Spend / Receive panels (match convert UI card) */\n.convert-page__ioPanel {\n  background: #f5f6f70a;\n  border-radius: 12px;\n  padding: 16px 18px 18px;\n  margin-bottom: 0;\n  min-height: 124px;\n}\n\nbody.light_theme .convert-page__ioPanel {\n  background: #F5F6F7;\n}\n\n.convert-page__ioPanel--compact {\n  min-height: auto;\n  padding: 16px 18px;\n}\n\n.convert-page__autoTopRight {\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__autoTopRight {\n  color: #0b0e11;\n}\n\n.convert-page__autoBigPct {\n  font-size: 28px;\n  font-weight: 700;\n  color: #f3f3f3;\n  line-height: 1.1;\n}\n\nbody.light_theme .convert-page__autoBigPct {\n  color: #2a2a2a;\n}\n\nbody.light_theme .convert-page__autoSelect {\n  color: #0b0e11;\n}\n\n.convert-page__autoSelect {\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.convert-page__autoAdvanced {\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 10px 2px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 800;\n  color: #fff;\n  cursor: pointer;\n}\n\nbody.light_theme .convert-page__autoAdvanced {\n  color: #0b0e11;\n}\n\n.convert-page__advancedPanel {\n  width: 100%;\n  padding: 8px 2px 2px;\n}\n\n.convert-page__advancedRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 0;\n  border-top: 1px solid rgb(64 64 64 / 35%);\n}\n\nbody.light_theme .convert-page__advancedRow {\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.convert-page__advancedLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgb(255 255 255 / 60%);\n}\n\nbody.light_theme .convert-page__advancedLabel {\n  color: rgba(11, 14, 17, 0.6);\n}\n\n.convert-page__advancedValueBtn {\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  color: #fff;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 6px 0;\n}\n\nbody.light_theme .convert-page__advancedValueBtn {\n  color: #0b0e11;\n}\n\n.convert-page__advancedValue {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.convert-page__advancedIcon {\n  font-size: 18px;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__advancedIcon {\n  color: #0b0e11;\n}\n\n.convert-page__switch {\n  width: 48px;\n  height: 28px;\n  border-radius: 999px;\n  border: none;\n  background: #e5e7eb;\n  padding: 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n  transition: background 160ms ease, box-shadow 160ms ease;\n}\n\n.convert-page__switchThumb {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.16);\n  transition: transform 160ms ease;\n}\n\n.convert-page__switch--on {\n  background: rgba(17, 24, 39, 0.25);\n  box-shadow: 0 0 0 1px rgba(17, 24, 39, 0.18) inset;\n  justify-content: flex-end;\n}\n\n.convert-page__switch--on .convert-page__switchThumb {\n  transform: translateX(0);\n}\n\n/* Plan Name modal (Advanced) */\n.convert-page__planModalOverlay {\n  position: fixed;\n  inset: 0;\n  /* background: rgba(0, 0, 0, 0.45); */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  z-index: 2147483647;\n  background-color: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  animation: cp-fade-in 160ms ease-out both;\n}\n\n.convert-page__planModal {\n  width: min(720px, 100%);\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  animation: cp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.convert-page__planModalHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 26px 14px;\n}\n\n.convert-page__planModalTitle {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.convert-page__planModalClose {\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #9aa0a6;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n.convert-page__planModalClose:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.convert-page__planModalBody {\n  padding: 0 26px 18px;\n}\n\n.convert-page__planModalInput {\n  width: 100%;\n  border: none;\n  background: #f3f4f6;\n  border-radius: 12px;\n  padding: 14px 14px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: #111827;\n  outline: none;\n}\n\n.convert-page__planModalFoot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  padding: 12px 26px 22px;\n}\n\n.convert-page__planBtn {\n  border: none;\n  border-radius: 999px;\n  padding: 12px 22px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.convert-page__planBtn--ghost {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.convert-page__planBtn--primary {\n  background: #303236;\n  color: #fff;\n}\n\n/* Dark Theme Overrides for Plan Modal */\nbody:not(.light_theme) .convert-page__planModalOverlay {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\nbody:not(.light_theme) .convert-page__planModal {\n  background: #181a20cf;\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .convert-page__planModalTitle {\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .convert-page__planModalClose {\n  color: #848e9c;\n}\n\nbody:not(.light_theme) .convert-page__planModalClose:hover {\n  background: #2b3139;\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .convert-page__planModalInput {\n  background: #2b3139;\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .convert-page__planBtn--ghost {\n  background: #2b3139;\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .convert-page__planBtn--primary {\n  background: #d1aa67;\n  color: #ffffff;\n}\n\n/* Auto-Invest schedule picker popover */\n.convert-page__ioTop {\n  position: relative;\n}\n\n.convert-page__investPopover {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 18px);\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  z-index: 10;\n  --cp-invest-head-h: 34px;\n  --cp-invest-head-gap: 8px;\n  --cp-invest-row-h: 48px;\n}\n\n.convert-page__investCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  height: 100%;\n}\n\n.convert-page__investCol {\n  padding: 16px 18px 14px;\n  min-width: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  max-height: calc(var(--cp-invest-head-h) + var(--cp-invest-head-gap) + (7 * var(--cp-invest-row-h)));\n}\n\n.convert-page__investCol+.convert-page__investCol {\n  border-left: 1px solid #eef0f2;\n}\n\n.convert-page__investColHead {\n  font-size: 16px;\n  font-weight: 600;\n  /* color: #9aa0a6; */\n  /* height: var(--cp-invest-head-h); */\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--cp-invest-head-gap);\n}\n\n.convert-page__investRow {\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 12px 6px;\n  min-height: var(--cp-invest-row-h);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  border-radius: 12px;\n}\n\n.convert-page__investRow:hover {\n  background: #f4f5f7;\n}\n\n.convert-page__investRowText {\n  font-size: 15px;\n  font-weight: 400;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow-wrap: anywhere;\n  word-break: normal;\n}\n\n.convert-page__investCheck {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #111827;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n/* Invest At — mobile bottom sheet (portal) */\n.convert-page__investSheetOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2147483647;\n  background: rgb(255 255 255 / 20%);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0;\n  animation: cp-fade-in 160ms ease-out both;\n}\n\n.convert-page__investSheet {\n  width: 100%;\n  max-height: min(92vh, 920px);\n  background: #fff;\n  border-radius: 18px 18px 0 0;\n  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.2);\n  padding: 4px 0 calc(10px + env(safe-area-inset-bottom, 0px));\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  animation: cp-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes cp-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes cp-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes cp-sheet-up {\n  from {\n    transform: translateY(18px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .convert-page__planModalOverlay,\n  .convert-page__planModal,\n  .convert-page__investSheetOverlay,\n  .convert-page__investSheet {\n    animation: none !important;\n  }\n}\n\n.convert-page__investSheetHandle {\n  width: 44px;\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.12);\n  margin: 4px auto 6px;\n  flex-shrink: 0;\n}\n\n.convert-page__investPopover--mobileSheet {\n  position: relative;\n  left: auto;\n  right: auto;\n  top: auto;\n  overflow: visible;\n  z-index: auto;\n  box-shadow: none;\n  border-radius: 0;\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: min(78vh, 720px);\n  margin: 0 0 2px;\n  --cp-invest-head-h: 30px;\n  --cp-invest-head-gap: 6px;\n  --cp-invest-row-h: 44px;\n}\n\n.convert-page__investPopover--mobileSheet .convert-page__investCols {\n  height: 100%;\n  max-height: 100%;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr) minmax(0, 0.85fr);\n}\n\n.convert-page__investPopover--mobileSheet .convert-page__investCol {\n  padding: 8px 10px 8px;\n}\n\n.convert-page__investPopover--mobileSheet .convert-page__investColHead {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 0 2px;\n}\n\n.convert-page__investPopover--mobileSheet .convert-page__investRow {\n  gap: 6px;\n  padding: 10px 2px;\n  min-height: var(--cp-invest-row-h);\n}\n\n.convert-page__investPopover--mobileSheet .convert-page__investRowText {\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.convert-page__autoCoinWrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.convert-page__autoCoinMenu {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 10px);\n  width: 260px;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.06);\n  padding: 10px;\n  z-index: 5;\n}\n\n.convert-page__autoCoinItem {\n  width: 100%;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 10px;\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n}\n\n.convert-page__autoCoinItem:hover {\n  background: #f4f5f7;\n}\n\n.convert-page__autoCoinLeft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.convert-page__autoCoinMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.convert-page__autoCoinCode {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.convert-page__autoCoinBal {\n  font-size: 15px;\n  font-weight: 500;\n  color: #9aa0a6;\n  line-height: 16px;\n}\n\n.convert-page__autoCoinCheck {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #111827;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.convert-page__ioTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 0px;\n}\n\n.convert-page__ioCaption {\n  font-size: 15px;\n  color: var(--convert-c-muted);\n}\n\nbody.light_theme .convert-page__availDash {\n  color: #0b0e11;\n}\n\n.convert-page__ioAvail {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__ioAvail {\n  color: #1d1d1d;\n}\n\n.convert-page__availDash {\n  font-weight: 600;\n  color: #fff;\n}\n\n\n.Convert_mid_btc_del {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n\n.convert-page__swapMid {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0;\n  margin: 2px 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.convert-page__addBalBtn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 2px;\n}\n\n.convert-page__addBalCircle {\n  width: 14px;\n  height: 14px;\n  padding-bottom: 2px;\n  border-radius: 50%;\n  /* border: 1px solid #c8cdd3; */\n  background: #303236;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 15px;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.convert-page__addBalBtn:hover .convert-page__addBalCircle {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n.convert-page__ioMain {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.convert-page__coinSelect {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  background: transparent;\n  padding: 4px 0;\n  cursor: pointer;\n  font: inherit;\n  flex-shrink: 0;\n}\n\n.convert-page__coinSelect:hover .convert-page__coinTicker {\n  opacity: 0.85;\n}\n\n.convert-page__coin-icon {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.convert-page__coinTicker {\n  font-size: 17px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .convert-page__coinTicker {\n  color: #0b0e11;\n}\n\n.convert-page__caret {\n  font-size: 18px;\n  color: #98a2b3;\n  margin-left: 2px;\n}\n\n/* Select Coin modal (Spend selector) */\n.convert-page__coinModalOverlay {\n  position: fixed;\n  inset: 0;\n  /* background: rgba(0, 0, 0, 0.45); */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 2147483647;\n  background-color: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.convert-page__coinModal {\n  width: min(640px, 100%);\n  max-height: min(86vh, 760px);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Add Funds modal (reuses overlay + head/close styles) */\n.convert-page__fundsModal {\n  width: min(760px, 100%);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.convert-page__fundsBody {\n  padding: 0px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.convert-page__fundsCard {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 18px 18px;\n  border-radius: 14px;\n  border: 1px solid #eef0f2;\n  background: #ffffff8c;\n  cursor: pointer;\n  text-align: left;\n}\n\n.convert-page__fundsCard:hover {\n  border-color: #e5e7eb;\n  background: #fbfbfc;\n}\n\n.convert-page__fundsIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #111827;\n  font-size: 22px;\n}\n\n.convert-page__fundsMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.convert-page__fundsTitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.convert-page__fundsDesc {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e9299;\n  line-height: 1.35;\n}\n\n.convert-page__fundsSub {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e9299;\n}\n\n.convert-page__fundsMore {\n  width: 100%;\n  border: none;\n  background: transparent;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 0 10px;\n  cursor: pointer;\n}\n\n/* Auto-Invest \"Choose Coin\" modal */\n.convert-page__chooseModal {\n  width: min(720px, 100%);\n  max-height: min(86vh, 820px);\n  background: #ffffff18;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.convert-page__chooseBody {\n  padding: 0 24px 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.convert-page__chooseBanner {\n  width: 100%;\n  border: 1px solid #eef0f2;\n  background: #fff;\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  cursor: pointer;\n  text-align: left;\n  margin: 0 0 14px;\n}\n\n.convert-page__chooseBannerLeft {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.convert-page__chooseFlame {\n  font-size: 16px;\n}\n\n.convert-page__chooseList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 0 14px;\n}\n\n.convert-page__chooseRow {\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 12px 6px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  cursor: pointer;\n  text-align: left;\n}\n\n\n/* \n.convert-page__chooseRow--selected {\n  background: #f3f4f6;\n} */\n\n.convert-page__chooseLeft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.convert-page__chooseBox {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.convert-page__chooseBox--on {\n  background: #111827;\n  border-color: #111827;\n}\n\n.convert-page__chooseBox--on::after {\n  content: \"✓\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  height: 100%;\n  width: 100%;\n}\n\n.convert-page__chooseFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 20px 18px;\n}\n\n.convert-page__chooseChips {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n  max-width: 420px;\n  max-height: 76px;\n  overflow: auto;\n}\n\n.convert-page__chooseChip {\n  border: none;\n  background: #f3f4f6;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.convert-page__chooseActions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.convert-page__chooseCount {\n  font-size: 14px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.convert-page__chooseConfirm {\n  min-width: 180px;\n  padding: 14px 18px;\n  border-radius: 999px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.convert-page__chooseConfirm:disabled {\n  background: #eef0f2;\n  color: #c4c7ca;\n  cursor: not-allowed;\n}\n\n/* Featured Portfolios modal */\n.convert-page__featuredModal {\n  width: min(760px, 100%);\n  max-height: min(86vh, 860px);\n  background: #ffffff10;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.convert-page__featuredBody {\n  padding: 2px 24px 32px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.convert-page__featuredCard {\n  background: none;\n  /* border: 1px solid #f5f6f7; */\n  border-radius: 16px;\n  padding: 22px;\n  box-shadow: 0px 0px 4px #99999966;\n}\n\n.convert-page__featuredTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.convert-page__featuredMid .convert-page__featuredMetric:last-child {\n  align-items: end;\n}\n\n.convert-page__featuredTitleRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.convert-page__featuredTitle {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.convert-page__featuredInfo {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(17, 24, 39, 0.08);\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.convert-page__featuredCopy {\n  border: none;\n  background: #303236;\n  color: #fff;\n  padding: 10px 30px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.convert-page__featuredMid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 16px;\n  margin-bottom: 12px;\n}\n\n.convert-page__featuredMetric {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.convert-page__featuredLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9aa0a6;\n}\n\n.convert-page__featuredValue {\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.convert-page__featuredIcons {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.convert-page__featuredIcon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  object-fit: contain;\n  background: #fff;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.convert-page__featuredTags {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  color: #9aa0a6;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.convert-page__featuredTag {\n  color: #9aa0a6;\n}\n\n.convert-page__coinModalHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n}\n\n.convert-page__coinModalTitle {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.convert-page__coinModalClose {\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #9aa0a6;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n.convert-page__coinModalClose:hover {\n  color: #111827;\n}\n\n.convert-page__coinModalBody {\n  padding: 0 20px 18px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  -webkit-overflow-scrolling: touch;\n}\n\n.convert-page__coinModalTabs {\n  display: flex;\n  gap: 0;\n  background: #f3f4f6;\n  border-radius: 12px;\n  padding: 4px;\n  margin-bottom: 14px;\n}\n\n.convert-page__coinModalTab {\n  flex: 1 1 0;\n  border: none;\n  background: transparent;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 700;\n  color: #8e9299;\n  cursor: pointer;\n}\n\n.convert-page__coinModalTab--active {\n  background: #fff;\n  color: #111827;\n}\n\n.convert-page__coinModalSearch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 12px;\n  background: #f3f4f6;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n\n.convert-page__coinModalSearchIcon {\n  font-size: 18px;\n  color: #8e9299;\n}\n\n.convert-page__coinModalSearchInput {\n  border: none;\n  background: transparent;\n  flex: 1 1;\n  min-width: 0;\n  font: inherit;\n  font-size: 14px;\n  color: #262933;\n  outline: none;\n}\n\n.convert-page__coinModalFilters {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 4px 2px 10px;\n  margin-bottom: 8px;\n}\n\n.convert-page__coinModalFilter {\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  color: #8e9299;\n  cursor: pointer;\n  position: relative;\n  padding: 2px 0;\n}\n\n.convert-page__coinModalFilter--active {\n  color: #111827;\n}\n\n.convert-page__coinModalFilter--active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -6px;\n  height: 2px;\n  background: #111827;\n  border-radius: 2px;\n}\n\n.convert-page__coinModalList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  max-height: 520px;\n  padding-right: 4px;\n}\n\n.convert-page__coinModalFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 0 2px;\n}\n\n.convert-page__coinModalCheck {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.convert-page__coinModalCheck input {\n  width: 18px;\n  height: 18px;\n}\n\n.convert-page__coinModalConfirm {\n  min-width: 220px;\n  padding: 14px 22px;\n  border-radius: 999px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.convert-page__coinModalConfirm:disabled {\n  background: #eef0f2;\n  color: #c4c7ca;\n  cursor: not-allowed;\n}\n\n.convert-page__coinRow {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 12px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.convert-page__coinRow:hover {\n  background: #f4f5f7;\n}\n\n.convert-page__coinRow--active {\n  background: #f3f4f6;\n}\n\n.convert-page__coinRowIcon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.convert-page__coinRowMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.convert-page__coinRowTop {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.convert-page__coinRowCode {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.convert-page__coinRowBadge {\n  font-size: 12px;\n  font-weight: 800;\n  color: #d1aa67;\n  background: rgba(209, 170, 103, 0.18);\n  padding: 4px 8px;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.convert-page__coinRowName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #8e9299;\n}\n\n.convert-page__amountBlock {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.convert-page__amountBlock--receive {\n  justify-content: flex-start;\n}\n\n.convert-page__amountInput {\n  width: 100%;\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 24px;\n  font-weight: 700;\n  color: #C4C7CA;\n  text-align: right;\n  padding: 4px 0;\n  line-height: 1.2;\n}\n\n.convert-page__amountInput::placeholder {\n  color: #C4C7CA;\n  font-weight: 700;\n}\n\n.convert-page__amountInput:focus {\n  outline: none;\n}\n\n.convert-page__maxPill {\n  border: none;\n  background: #fff;\n  color: #000000;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 3px 9px;\n  border-radius: 50px;\n  cursor: pointer;\n}\n\n.convert-page__maxPill:hover {\n  border-color: #c8cdd3;\n  color: #0b0e11;\n}\n\n.convert-page__swapMid {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0;\n  margin: 2px 0;\n}\n\n.convert-page__swapBtn {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 1px solid #EBEBEB;\n  background: #F5F6F7;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #5e6673;\n  font-size: 22px;\n}\n\n.convert-page__swapBtn:hover {\n  color: #0b0e11;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);\n}\n\n.convert-page__rate {\n  margin: 12px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--convert-c-muted);\n  text-align: center;\n}\n\n.convert-page__cta {\n  display: block;\n  width: 100%;\n  margin-top: 18px;\n  padding: 15px 20px;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 500;\n  color: #fff;\n  background: #303236;\n  border-radius: 999px;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n}\n\n.convert-page__cta:hover {\n  filter: brightness(1.08);\n  color: #fff;\n}\n\n@media (max-width: 480px) {\n  .convert-page__ioMain {\n    flex-wrap: wrap;\n  }\n\n  .convert-page__amountBlock {\n    width: 100%;\n  }\n\n  .convert-page__amountInput {\n    font-size: 20px;\n  }\n\n  .convert-page__maxPill {\n    align-self: flex-end;\n  }\n}\n\n/* Supported assets */\n.convert-page__assetsSection {\n  padding: 90px 20px 90px;\n  max-width: 1240px;\n  margin: 0 auto;\n}\n\n.convert-page__sectionTitle {\n  margin: 0 0 10px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n  text-align: center;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .convert-page__sectionTitle {\n  color: #262626;\n}\n\n.convert-page__sectionSub {\n  margin: 0px auto 18px;\n  max-width: 520px;\n  text-align: center;\n  font-size: 16px;\n  line-height: 1.55;\n  color: var(--convert-c-muted);\n}\n\n.convert-page__assetGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 28px;\n}\n\n@media (max-width: 991px) {\n  .convert-page__assetGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n\n\n.convert-page__assetCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 20px;\n  cursor: pointer;\n  border: 1px solid #eaecef0f;\n  background: #ffffff0a;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px #00000015;\n  transition: 1s all;\n  text-decoration: none;\n  color: inherit;\n}\n\na.convert-page__assetCard:hover {\n  color: inherit;\n}\n\nbody.light_theme .convert-page__assetCard {\n  border: 1px solid #eaecef45;\n  background: #fff;\n}\n\n.convert-page__assetCard:hover {\n  transform: translateY(-5px);\n}\n\n.convert-page__assetCard--more {\n  cursor: default;\n}\n\n.convert-page__assetIconImg {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.convert-page__assetIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.convert-page__assetIcon--letter {\n  font-size: 18px;\n}\n\n.convert-page__assetIcon--more {\n  color: #000000;\n  font-size: 24px;\n  letter-spacing: 2px;\n}\n\n.convert-page__assetMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.convert-page__assetName {\n  font-size: 18px;\n  font-weight: 500;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__assetName {\n  color: #0b0e11;\n}\n\n.convert-page__assetHint {\n  font-size: 16px;\n  /* font-weight: 500; */\n  color: var(--convert-c-muted);\n}\n\n/* FAQ */\n.convert-page__faqSection {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 0 20px 72px;\n  color: #fff;\n}\n\nbody.light_theme .convert-page__faqSection {\n  color: #0b0e11;\n}\n\n.convert-page__faqTitle {\n  margin: 0 0 24px;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.convert-page__faqList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.convert-page__faqBtn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 4px;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: left;\n  color: #ffffffc7;\n  cursor: pointer;\n}\n\nbody.light_theme .convert-page__faqBtn {\n  color: #050606;\n}\n\n/* .convert-page__faqBtn:hover {\n  color: var(--convert-c-muted);\n} */\n\n.convert-page__faqChev {\n  font-size: 22px;\n  color: var(--convert-c-muted);\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.convert-page__faqChev--open {\n  transform: rotate(180deg);\n}\n\n.convert-page__faqPanel {\n  padding: 0 4px 18px;\n  font-size: 18px;\n  line-height: 1.65;\n  color: var(--convert-c-muted);\n}\n\n.convert-page__faqPanel p {\n  margin: 0;\n  font-size: 18px;\n}\n\n@media (max-width: 1440px) {\n\n  .convert-page__title {\n    font-size: 36px;\n  }\n\n\n}\n\n\n\n@media (max-width: 1200px) {\n\n  .convert-page__title {\n    font-size: 30px;\n  }\n\n  .convert-page__faqBtn {\n    font-size: 16px;\n  }\n\n  .convert-page__faqPanel p {\n    font-size: 15px;\n  }\n\n  .convert-page__faqTitle {\n    font-size: 26px;\n  }\n\n  .convert-page__lead {\n    font-size: 15px;\n  }\n\n  .convert-page__amountInput {\n    font-size: 18px;\n  }\n\n  .convert-page__hero {\n    min-height: 650px;\n  }\n\n\n}\n\n\n@media (max-width: 991px) {\n\n  .convert-page__hero {\n    min-height: 100%;\n    padding: 30px 20px 50px;\n  }\n\n  .convert-page__coinModalOverlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .convert-page__investRow:hover {\n    background: none;\n  }\n\n  .convert-page__coin-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .convert-page__coinTicker {\n    font-size: 15px;\n  }\n\n  .convert-page__cta {\n    margin-top: 10px;\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n\n  .convert-page__coinModal {\n    width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .convert-page__fundsModal {\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .convert-page__chooseModal {\n    width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .convert-page__planModalOverlay {\n    align-items: end;\n  }\n\n  .convert-page__planModal {\n    width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .convert-page__fundsBody {\n    height: 75vh;\n    overflow: scroll;\n  }\n\n  .convert-page__heroInner {\n    grid-template-columns: 1fr;\n  }\n\n  .convert-page__swapBtn {\n    width: 50px;\n    padding: 0px;\n    height: 50px;\n  }\n\n  .convert-page__featuredModal {\n    width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .convert-page__coinModalTitle {\n    width: 90%;\n    font-size: 20px;\n  }\n\n  .convert-page__lead {\n    display: none;\n  }\n\n  .convert-page__title {\n    font-size: 24px;\n    text-align: center;\n  }\n\n  .convert-page__heroInner {\n    gap: 15px;\n  }\n\n  .convert-page__card {\n    padding: 20px;\n  }\n\n  .convert-page__hero {\n    padding: 30px 15px 30px;\n  }\n\n  .convert-page__featuredTitle {\n    font-size: 16px;\n  }\n\n  .convert-page__featuredCopy {\n    padding: 8px 20px;\n    font-size: 13px;\n  }\n\n  .convert-page__planBtn {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n\n  .convert-page__chooseConfirm {\n    min-width: 150px;\n    padding: 10px 18px;\n    font-size: 14px;\n  }\n\n  .convert-page__autoCoinItem {\n    padding: 8px 5px;\n  }\n\n  .convert-page__autoCoinMenu {\n    width: 200px;\n  }\n\n  .convert-page__featuredCard {\n    padding: 18px;\n  }\n\n  .convert-page__autoBigPct {\n    font-size: 20px;\n  }\n\n  .convert-page__coinRow {\n    padding: 8px;\n  }\n\n  .convert-page__sectionSub {\n    font-size: 15px;\n  }\n\n  .convert-page__faqTitle {\n    font-size: 22px;\n  }\n\n  .convert-page__faqBtn {\n    padding: 10px 4px;\n    font-size: 15px;\n  }\n\n  .convert-page__faqPanel p {\n    font-size: 14px;\n  }\n\n  .simple_earn_wrapper .convert-page__faqSection {\n    padding: 0 0px 30px;\n    margin: 20px 0px !important;\n  }\n\n}\n\n\n@media (max-width: 660px) {\n\n  .convert-page__assetGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n  }\n\n\n  .convert-page__fundsCard {\n    padding: 15px;\n  }\n\n  .convert-page__planModalTitle {\n    font-size: 20px;\n    width: 90%;\n  }\n\n  .convert-page__assetCard {\n    padding: 15px;\n  }\n\n  .convert-page__assetIconImg {\n    width: 30px;\n    height: 30px;\n  }\n\n  .convert-page__assetName {\n    font-size: 15px;\n  }\n\n  .convert-page__assetHint {\n    font-size: 14px;\n  }\n\n  .convert-page__amountInput {\n    font-size: 15px;\n  }\n\n  .convert-page__coinRowCode {\n    font-size: 14px;\n  }\n\n}\n\n/* ==========================================\n   Dark Theme (Default) Overrides for Modals\n   ========================================== */\nbody:not(.light_theme) .convert-page__coinModalOverlay {\n  background-color: rgba(0, 0, 0, 0.20);\n}\n\nbody:not(.light_theme) .convert-page__coinModal,\nbody:not(.light_theme) .convert-page__fundsModal,\nbody:not(.light_theme) .convert-page__chooseModal,\nbody:not(.light_theme) .convert-page__featuredModal {\n  background: #111214c2;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  box-shadow: 0 20px 60px rgb(0 0 0 / 70%);\n}\n\nbody:not(.light_theme) .convert-page__coinModalTitle {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinModalClose {\n  color: #9aa0a6;\n}\n\nbody:not(.light_theme) .convert-page__coinModalClose:hover {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinModalTabs {\n  background: #1e2329;\n}\n\nbody:not(.light_theme) .convert-page__coinModalTab {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__coinModalTab--active {\n  background: #2b313c;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinModalSearch {\n  background: #1e2329;\n  border: 1px solid rgba(255, 255, 255, 0);\n}\n\nbody:not(.light_theme) .convert-page__coinModalSearchIcon {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__coinModalSearchInput {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinModalFilter {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__coinModalFilter--active {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinModalFilter--active::after {\n  background: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinRow,\nbody:not(.light_theme) .convert-page__chooseRow,\nbody:not(.light_theme) .convert-page__autoCoinItem,\nbody:not(.light_theme) .convert-page__investRow {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__coinRow:hover,\nbody:not(.light_theme) .convert-page__chooseRow:hover,\nbody:not(.light_theme) .convert-page__autoCoinItem:hover,\nbody:not(.light_theme) .convert-page__investRow:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody:not(.light_theme) .convert-page__coinRow--active {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .convert-page__coinRowName,\nbody:not(.light_theme) .convert-page__autoCoinBal,\nbody:not(.light_theme) .convert-page__chooseBox,\nbody:not(.light_theme) .convert-page__fundsDesc,\nbody:not(.light_theme) .convert-page__fundsSub {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__coinRowCode,\nbody:not(.light_theme) .convert-page__coinRowBalVal,\nbody:not(.light_theme) .convert-page__autoCoinCode,\nbody:not(.light_theme) .convert-page__chooseConfirm,\nbody:not(.light_theme) .convert-page__coinModalConfirm,\nbody:not(.light_theme) .convert-page__fundsTitle {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__fundsCard {\n  background: #1e23295e;\n  border-color: rgb(255 255 255 / 6%);\n}\n\nbody:not(.light_theme) .convert-page__fundsCard:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\nbody:not(.light_theme) .convert-page__fundsIcon {\n  background: #2b313c;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__fundsMore {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__chooseBox {\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: transparent;\n}\n\nbody:not(.light_theme) .convert-page__chooseBox--on {\n  background: #ffffff;\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__chooseBox--on::after {\n  color: #111214;\n}\n\nbody:not(.light_theme) .convert-page__chooseConfirm,\nbody:not(.light_theme) .convert-page__coinModalConfirm {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .convert-page__chooseConfirm:disabled,\nbody:not(.light_theme) .convert-page__coinModalConfirm:disabled {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.3);\n}\n\nbody:not(.light_theme) .convert-page__coinModalCheck {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__chooseChip {\n  background: #2b313c;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__chooseCount {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__chooseBanner {\n  background: #1e232910;\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .convert-page__chooseBannerLeft {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__featuredCard {\n  background: #1e232910;\n  box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .convert-page__featuredTitle {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__featuredInfo {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__featuredLabel {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__featuredValue {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__featuredTag {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__featuredCopy {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .convert-page__coinModalFoot,\nbody:not(.light_theme) .convert-page__chooseFoot {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .convert-page__autoCoinMenu {\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .convert-page__autoCoinCheck {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .convert-page__investPopover {\n  background: #111214;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .convert-page__investCol+.convert-page__investCol {\n  border-left: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .convert-page__investRow:hover {\n  background: #2b313c;\n}\n\nbody:not(.light_theme) .convert-page__investRowText {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .convert-page__investColHead {\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .convert-page__investCheck {\n  background: #ffffff;\n  color: #111214;\n}\n\n\n@media screen and (max-width:580px) {\n\n\n  .convert-page__faqBtn {\n    padding: 10px 4px;\n    font-size: 13px;\n  }\n\n  .convert-page__faqPanel p {\n    font-size: 13px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
